// extracted by mini-css-extract-plugin
export default {"addressLabel":"AddressLabel_addressLabel__COqdB","enterManuallyButton":"AddressLabel_enterManuallyButton__iXXB7"};